<template>
  <div class="uploadImg">
    <div class="comment_uploadimg">
      <!-- <van-uploader  v-model="comment_imgbox" multiple :max-count="6" preview-size="55"/> -->
      <div class="van-uploader__wrapper">
        <div v-if="uploadBox.localIds.length > 0" class="fl">
          <div class="van-uploader__upload fl"  v-for="(item,index) in uploadBox.localIds" :key="index">
            <img :src="item" class="radius" alt @click="previewImage(item)" style="height: 100%;"/>
            <p
              class="close fs_12"
              @click="deleImg(index)"
              style="position: absolute;top: 0;right: .2rem;font-size: 1rem !important;color:#45b9bc;"
            >×</p>
          </div>
        </div>

        <div
          class="van-uploader__upload fl"
          v-if="uploadBox.localIds.length < count"
          @click="selectImg"
        >
          <i class="van-icon van-icon-plus van-uploader__upload-icon">
            <!---->
          </i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "uploadImg",
  components: {},
  props: ["count", "Box"],
  data() {
    return {
      uploadBox: this.Box
    };
  },
  created() {
  },
  methods: {
    selectImg() {
      var that = this;
      this.axios({
        url: this.api.index.share_url,
        data: {
          url: window.location.href.split("#")[0]
        }
      }).then(function(res) {
        var shareMsg = res.jssdkconfig;
        wx.config({
          appId: shareMsg.appId,
          timestamp: shareMsg.timestamp,
          nonceStr: shareMsg.nonceStr,
          signature: shareMsg.signature,
          jsApiList: ["chooseImage", "uploadImage", "previewImage"]
        });
        wx.ready(function() {
          wx.chooseImage({
            count: 1, // 默认9
            sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
            success: function(res) {
              res.localIds.forEach(v => {
                // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                that.uploadBox.localIds.push(v);
                that.upLoad_img();
              });
            }
          });
        });
      });
    },
    previewImage(url) {
      // 图片预览
      var that = this;
      wx.previewImage({
        current: url, // 当前显示图片的http链接
        urls: that.uploadBox.localIds // 需要预览的图片http链接列表
      });
    },
    deleImg(i) {
      this.uploadBox.localIds.splice(i, 1);
      this.uploadBox.serverId.splice(i, 1);
      this.$emit("uploadImg", this.uploadBox);
    },
    upLoad_img() {
      var that = this;
      // var i = 0;
      var count = that.uploadBox.localIds.length;
      function upLoad() {
        // 多图上传
        wx.uploadImage({
          count:1,
          localId: that.uploadBox.localIds[count - 1], // 需要上传的图片的本地ID，由chooseImage接口获得
          isShowProgressTips: 1, // 默认为1，显示进度提示
          complete: function(res) {
            // i++;
            that.uploadBox.serverId.push(res.serverId); // 返回图片的服务器端ID
            that.$emit("uploadImg", that.uploadBox);
            // if (i < count) {
            //   upLoad(); // 递归上传图片
            // } else {
            //   //that.post();
            // }
          }
        });
      }
      upLoad();
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/uploadImg.vue